import addRequestHeaders from './addRequestHeaders.js';

var DealViewerContext;
(function (DealViewerContext) {
    DealViewerContext["CONSUMER"] = "CONSUMER";
    DealViewerContext["OPERATIONS"] = "OPERATIONS";
    DealViewerContext["BUSINESS"] = "BUSINESS";
})(DealViewerContext || (DealViewerContext = {}));
function viewerContextLink(viewerContext) {
    return addRequestHeaders(function () {
        if (viewerContext) {
            return { 'X-Deal-Viewer-Context': viewerContext() };
        }
        else {
            return {};
        }
    });
}

export default viewerContextLink;
export { DealViewerContext };
//# sourceMappingURL=viewerContext.js.map
